var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExclamationDoodleLinesBottom = function SvgExclamationDoodleLinesBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F2DD3",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M22.979 10.564c-2.803 3.87-7.142 7.833-8.05 12.69M32.146 13.315c1.28 5.38 1.988 9.165 5.641 13.22M2.844 6.802c5.507-1.284 11.129-2.61 16.774-2.95"
  })));
};
export default SvgExclamationDoodleLinesBottom;